<script>
   import AgGrid from "@budibase/svelte-ag-grid";
   import "ag-grid-community/styles/ag-grid.css";
   import "ag-grid-community/styles/ag-theme-alpine-dark.css";

   export let attempts = [];
   let attemptsColumnDefs = [];

   const gridOptions = {
      defaultColDef: {
         flex: 1,
         minWidth: 200,
         filter: true,
         sortable: true,
         editable: false,
         suppressMovable: true,
         resizable: true,
      },
      suppressFieldDotNotation: true,
      rowSelection: "multiple",
      sideBar: {
         position: 'left',
         toolPanels: ['columns']
      }
   };

   $: if(attempts) {
      let newColDefs = [];

      for(let row of attempts) {
         Object.keys(row).forEach(x => {
            if(!newColDefs.includes(x)) {
               newColDefs.push(x);
            }
         });
      }

      newColDefs = newColDefs.map(x => {
         return {
            headerName: x[0].toUpperCase() + x.substring(1),
            field: x,
            sortable: true,
            editable: false,
            filter: true,
            resizable: true
         };
      });

      if(newColDefs.length > 0) {
         newColDefs[newColDefs.length - 1].resizable = false;
         attemptsColumnDefs = newColDefs;
      }
   }
</script>

{#if attempts}
    <div class="attempts-grid-wrapper">
        <AgGrid bind:data={attempts} columnDefs={attemptsColumnDefs} options={gridOptions} height="100%"/>
    </div>
{:else}
    <h3>One Moment...</h3>
{/if}

<style>
    .attempts-grid-wrapper {
        --grid-height: 20em
    }
</style>